import { render } from "./AppDialog.vue?vue&type=template&id=973dce94"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script